import React from 'react';
import PropTypes from 'prop-types';
import CtiActionButton from 'flow/components/integration/IntegrationActionButton';
import { isURL } from 'flow/utils/call-widget-utils';
import { openCallWidgetLink } from 'flow/actions/run-url-actions';

const GenericCallWidgetFooter = ({ buttons, darkMode }) => (
    <div className="flex flex-wrap justify-end gap-3 p-3 pb-0">
        {buttons.map(({ actionUrl, actionLabel, actionCallback }, index) => {
            actionCallback = actionCallback || (() => {});
            const linkEnabled = isURL(actionUrl);
            return (
                <CtiActionButton
                    key={index}
                    label={actionLabel}
                    disabled={!linkEnabled}
                    handleClick={() => {
                        actionCallback();
                        if (actionUrl && linkEnabled) {
                            openCallWidgetLink(actionUrl);
                        }
                    }}
                    darkMode={darkMode}
                />
            );
        })}
    </div>
);

GenericCallWidgetFooter.propTypes = {
    buttons: PropTypes.arrayOf(
        PropTypes.shape({
            actionLabel: PropTypes.string,
            actionUrl: PropTypes.string,
            actionCallback: PropTypes.func,
        }),
    ),
    darkMode: PropTypes.bool.isRequired,
};

export default React.memo(GenericCallWidgetFooter);
